import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-24676ea4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "dropdown" };
const _hoisted_2 = ["id"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" }, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = ["aria-labelledby"];
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
            id: `dropdown-label-${$props.label}`,
            href: "#",
            class: "dropdown-toggle",
            role: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
        }, _hoisted_4, 8, _hoisted_2),
        _createElementVNode("div", {
            class: "dropdown-menu",
            "aria-labelledby": `dropdown-label-${$props.label}`
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.actions, (action) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: action.title
                }, [
                    (!action.hidden)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: _normalizeClass(['dropdown-item', { disabled: action.disabled }]),
                            onClick: _withModifiers(action.action, ["prevent"])
                        }, _toDisplayString(_ctx.$t(`${action.name}`)), 11, _hoisted_6))
                        : _createCommentVNode("", true)
                ]));
            }), 128))
        ], 8, _hoisted_5)
    ]));
}
